export default __webpack_public_path__ + "static/media/6.ee3d0db5.png";